import { useI18n } from 'next-localization';
import ArticleTypes from '@/constants/article';

type Props = {
  articleType: string;
  duration?: number;
  className?: string;
};

const Readtime = ({ articleType, duration, className }: Props) => {
  const { t } = useI18n();

  if (!duration) {
    return null;
  }

  const type: string =
    ArticleTypes[articleType?.toLowerCase() as keyof typeof ArticleTypes] ?? articleType;

  const componentContent =
    type === 'Article'
      ? { icon: 'bi-justify-left', dictionary: t('read') }
      : type === 'Video' || type === 'webinar'
      ? { icon: 'bi-play-circle', dictionary: t('watch') }
      : type === 'Podcast'
      ? { icon: 'bi-mic', dictionary: t('listen') }
      : { icon: 'bi-justify-left', dictionary: t('read') };

  return (
    <span className={`article__readtime d-flex align-items-center ${className}`}>
      <span className="article__readtime__icon d-flex align-items-center">
        <i
          data-testid={'readtime-icon'}
          className={`bi ${componentContent.icon} me-1`}
          style={{ fontSize: 24 }}
          aria-hidden={true}
        />
        <span>
          {duration} min {componentContent.dictionary}
        </span>
      </span>
    </span>
  );
};

export default Readtime;
